<div class="av-metric-card__head">
  <h2 class="av-metric-label m-0">{{ 'app.reports.monitoring.approvalRate.title' | translate }}</h2>
  <av-status-pill
    class="av-metric-card__chip"
    variant="muted"
    icon="calendar_month"
    [label]="monthName()"
  />
</div>
<div class="av-metric-card__figure av-metric-card__figure--trend">
  <p class="av-metric-value m-0">{{ rate() | percent: '1.1-1' : language() }}</p>
  @if (delta() !== null) {
    <app-monitoring-delta
      [percent]="delta() ?? 0"
      [progress]="progress()"
      [previousFrom]="previousFrom()"
      unit="points"
    />
  }
</div>
